export default {
	name: 'task_0',
	description: 'Заставка',
	title: 'Игра «Уголовный закон»',
	minigameType: 'Greeting',
	mode: 0,
	messages() {
		return {
			onStart: 'Приветствуем в демо-версии игры «Уголовный закон», предназначенной для свободного доступа. Здесь вы сможете ознакомиться с основным функционалом игры.',
		};
	},
	generateParams() {
		return {};
	},
	isCompleted: () => true,
	score: 0,
	maxScore: 0,

};